import { type FC } from 'react';
import { ItemTilesCarouselShimmer } from 'dibs-product-tile-carousel/exports/ItemTilesCarouselShimmer.ts';
import { useSharedCarouselProps } from '../HpSharedItemTilesCarouselModule/useSharedCarouselProps.ts';
import { HpSharedFeaturedItemsTitle } from './HpSharedFeaturedItemsTitle.tsx';

import dibsCss from 'dibs-css';

export const HpSharedFeaturedItemsCarouselLoading: FC<{ isMobile: boolean }> = ({ isMobile }) => {
    const { fullWidth, gapSize, itemsToShow, showArrows, tileSize } = useSharedCarouselProps({
        isMobile,
    });
    return (
        <div className={isMobile ? dibsCss.mbMedium : dibsCss.mbLarger}>
            <HpSharedFeaturedItemsTitle isMobile={isMobile} isLoading />
            <ItemTilesCarouselShimmer
                fullWidth={fullWidth}
                gapSize={gapSize}
                itemsToShow={itemsToShow}
                showArrows={showArrows}
                size={tileSize}
            />
        </div>
    );
};
